export enum FlowNodeTypes {
  ACTION = 'action',
  AUDIO_MESSAGE = 'announcement',
  AUTOREPLY = 'autoreply',
  BUSINESS_HOURS = 'businesshours',
  CALL_RECORDING = 'callrecording',
  CALLBACK = 'callback',
  CHAT_INPUT = 'chatinput',
  CHAT_MENU = 'chatmenu',
  CHAT_MESSAGE = 'chatmessage',
  CLOSE = 'close',
  CONTACT_FORM = 'contactform',
  CONTENT = 'content',
  DIAL_INPUT = 'externaldataphoneinput',
  FILTERS = 'externaldatarouting',
  FORWARD = 'forward',
  HIDDEN = 'hidden',
  HIDE_STRATEGY = 'hidestrategy',
  INIT = 'init',
  INTEGRATION = 'fetchexternaldata',
  INTENT_DETECTION = 'intentdetection',
  IVR_MENU = 'ivrmenu',
  LOCATIONS = 'phonenumber',
  MESSENGER_AVAILABILITY = 'messengeravailability',
  MESSENGER_INPUT = 'messengerinputfield',
  MESSENGER_MENU = 'messengermenu',
  MESSENGER_MESSAGE = 'messengermessage',
  CHATBOT = 'chatbot',
  MESSENGER_FORM = 'messengerform',
  OPENING_HOURS = 'openinghours',
  QUEUE = 'queue',
  RECORD_CONVERSATION = 'callrecording',
  TAGS = 'tags',
  URL = 'url',
  VOICEMAIL = 'voicemail',
  WIDGET_CUSTOMIZATION = 'widgetcustomization',

  // Subflow nodes

  /**
   * Subflow init is only used in backend. In frontend we simply use the init
   * node inside the subflows.
   */
  SUBFLOW_INIT = 'subflowinit',
  SUBFLOW_REFERENCE = 'subflowreference',
  SUBFLOW_RETURN = 'subflowreturn',
}

export enum MatchingStrategy {
  ALL = 'all',
  ANY = 'any',
}

export enum MatchingOperator {
  CONTAINS = 'contains',
  ENDS_WITH = 'suffix',
  EQUALS = 'equals',
  GREATER_THAN = 'gt',
  GREATER_THAN_OR_EQUAL = 'gte',
  IS_EMPTY = 'is-empty',
  IS_NOT_EMPTY = 'is-not-empty',
  LESS_THAN = 'lt',
  LESS_THAN_OR_EQUAL = 'lte',
  NOT_CONTAINS = 'not-contains',
  NOT_EQUALS = 'not-equals',
  STARTS_WITH = 'prefix',
}

export enum ContentType {
  APPLICATION_JSON = 'application/json',
  APPLICATION_JAVASCRIPT = 'application/javascript',
  APPLICATION_XML = 'application/xml',
  APPLICATION_X_WWW_FORM_URLENCODED = 'application/x-www-form-urlencoded',
  TEXT_PLAIN = 'text/plain',
  TEXT_JAVASCRIPT = 'text/javascript',
  TEXT_XML = 'text/xml',
  TEXT_HTML = 'text/html',
  TEXT_CSV = 'text/csv',
}

export enum ConditionOutcome {
  MATCH = 'Match',
  NO_MATCH = 'No match',
}

export enum RuleType {
  CEL_EXPRESSION = 'cel_expression',
}

// A branch rule expressed as a raw CEL expression instead of variable/operator/match.
export type CelExpressionRule = {
  type: RuleType.CEL_EXPRESSION;
  expression: string;
};

export const isCelExpressionRule = (rule: unknown): rule is CelExpressionRule =>
  typeof rule === 'object' &&
  rule !== null &&
  'type' in rule &&
  (rule as { type?: unknown }).type === RuleType.CEL_EXPRESSION;

export enum Day {
  Sunday = 'Sun',
  Monday = 'Mon',
  Tuesday = 'Tue',
  Wednesday = 'Wed',
  Thursday = 'Thu',
  Friday = 'Fri',
  Saturday = 'Sat',
}

export type OptionT<T = string> = {
  label: string;
  value: T;
};
